import { countryLabel } from './happeningNowFeed';

/**
 * ISO 3166-1 alpha-2 → flag emoji (e.g. PT → 🇵🇹).
 */
export function countryCodeToFlagEmoji(code) {
  const normalized = String(code || '').toUpperCase();
  if (!/^[A-Z]{2}$/.test(normalized)) return null;

  return String.fromCodePoint(
    ...normalized.split('').map(char => 0x1F1E6 + char.charCodeAt(0) - 65)
  );
}

/**
 * Resolve region context for a ticker item using item fields and its section.
 */
export function resolveTickerRegion(item, section) {
  const scope = item?.scope === 'country' || section?.scope === 'country'
    ? 'country'
    : 'global';

  const countryCode = String(
    item?.countryCode || section?.countryCode || ''
  ).toUpperCase() || null;

  return { scope, countryCode };
}

export function getTickerRegionLabel(scope, countryCode) {
  if (scope === 'country' && countryCode) {
    return countryLabel(countryCode);
  }
  return 'Worldwide';
}
